import Alpine from 'alpinejs';
import axios from '../../config/axios.js';

function createKasirSurangTemplates() {
  return {
    templates: [],
    products: [],
    loading: false,
    saving: false,
    modal: false,
    editing: false,
    form: {
      id: null,
      name: '',
      product_id: '',
      access: 'free',
      min_level: 0,
      is_active: true,
      sort_order: 0,
      width_mm: 500,
      height_mm: 300,
    },

    init() {
      try {
        const cfg = JSON.parse(this.$el.getAttribute('data-config') || '{}');
        this.templates = cfg.templates || [];
        this.products = cfg.products || [];
      } catch (e) {
        console.error(e);
      }
    },

    openCreate() {
      this.editing = false;
      this.form = {
        id: null,
        name: '',
        product_id: this.products[0]?.id || '',
        access: 'free',
        min_level: 0,
        is_active: true,
        sort_order: this.templates.length + 1,
        width_mm: 500,
        height_mm: 300,
      };
      this.modal = true;
    },

    openEdit(t) {
      this.editing = true;
      this.form = {
        id: t.id,
        name: t.name || '',
        product_id: t.product_id || '',
        access: t.access || 'free',
        min_level: t.min_level || 0,
        is_active: !!t.is_active,
        sort_order: t.sort_order || 0,
        width_mm: t.scene_json?.width_mm || 500,
        height_mm: t.scene_json?.height_mm || 300,
      };
      this.modal = true;
    },

    async save() {
      this.saving = true;
      try {
        const body = {
          name: this.form.name,
          product_id: this.form.product_id || null,
          access: this.form.access,
          min_level: this.form.min_level,
          is_active: this.form.is_active,
          sort_order: this.form.sort_order,
          width_mm: this.form.width_mm,
          height_mm: this.form.height_mm,
        };
        if (this.editing) {
          const { data } = await axios.put(`/api/v1/kasir/engagement/surang-templates/${this.form.id}`, body);
          const idx = this.templates.findIndex((t) => t.id === data.data.id);
          if (idx >= 0) this.templates[idx] = data.data;
          window.toast?.(data.message || 'Diperbarui.', 'success');
        } else {
          const { data } = await axios.post('/api/v1/kasir/engagement/surang-templates', body);
          this.templates.unshift(data.data);
          window.toast?.(data.message || 'Ditambahkan.', 'success');
        }
        this.modal = false;
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal menyimpan.', 'error');
      } finally {
        this.saving = false;
      }
    },

    async remove(t) {
      const ok = await window.confirmDialog?.({
        title: 'Hapus template?',
        message: `Hapus ${t.name}?`,
        confirmText: 'Hapus',
        variant: 'danger',
      });
      if (!ok) return;
      try {
        await axios.delete(`/api/v1/kasir/engagement/surang-templates/${t.id}`);
        this.templates = this.templates.filter((x) => x.id !== t.id);
        window.toast?.('Template dihapus.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal hapus.', 'error');
      }
    },
  };
}

Alpine.data('kasirSurangTemplates', createKasirSurangTemplates);
